// organize-imports-ignore
import '@babel/polyfill';
import 'array-flat-polyfill';
import 'event-propagation-path';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App.tsx';
import setupStore, { history } from './store';
import { ShippoTools } from './utils/browser-tools';

if (CONFIG.showTools) {
  new ShippoTools();
}

// Grab the state from a global variable injected into the server-generated HTML
const preloadedState = window.__PRELOADED_STATE__;

// Allow the passed state to be garbage-collected
delete window.__PRELOADED_STATE__;

const store = setupStore(preloadedState);

// Segment initialization
const loadSegment = () => {
  if (analytics && CONFIG.segment)
    analytics.load(CONFIG.segment, {
      integrations: {
        'Segment.io': {
          deliveryStrategy: {
            strategy: 'batching',
            config: {
              size: 25,
              timeout: 1000,
            },
          },
        },
      },
    });
};

function runApp() {
  window.stackables = [];

  loadSegment();

  // eslint-disable-next-line react/no-render-return-value
  return ReactDOM.render(
    <Provider store={store}>
      <App history={history} />
    </Provider>,
    document.getElementById('appContent'),
  );
}

if (!global.Intl) {
  require.ensure(['intl', 'intl/locale-data/complete.js'], function (require) {
    require('intl');
    require('intl/locale-data/complete.js');
    runApp();
  });
} else {
  runApp();
}
